export const afsExcelUiModuleId = "07e49a18-a187-4e03-992d-7eb9487b6d42";
export const afsExcelUiPageId = "ff6560a7-2a5b-479f-8592-07ce25da0cd0";
export const afsExcelUiLogisImportsPageId =
  "53c66f75-3ed9-4f23-b4c0-5aa29b437fd4";
export const afsExcelUiFinancialReportingImportsPageId =
  "f044916e-b150-4e1d-bb7f-3f0e1b2c2ab1";
export const afsExcelUiProgrammeStructurePageId =
  "2b732b23-733d-4c77-bdfb-6c72bfbd9d44";
